"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCheckoutRedirectionCookie = exports.addCheckoutRedirectionCookie = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var CHECKOUT_REDIRECT_COOKIE = 'returnToCheckout';
var addLoginRedirectToField = function () {
    if (js_cookie_1.default.get(CHECKOUT_REDIRECT_COOKIE)) {
        $('#customer_login').append('<input type="hidden" name="return_to" value="/pages/checkout" />');
    }
};
var addSignupRedirectToField = function () {
    if (js_cookie_1.default.get(CHECKOUT_REDIRECT_COOKIE)) {
        $('#create_customer').append('<input type="hidden" name="return_to" value="/pages/checkout" />');
    }
};
var addCheckoutRedirectionCookie = function () {
    js_cookie_1.default.set(CHECKOUT_REDIRECT_COOKIE, '1');
};
exports.addCheckoutRedirectionCookie = addCheckoutRedirectionCookie;
var clearCheckoutRedirectionCookie = function () {
    js_cookie_1.default.remove(CHECKOUT_REDIRECT_COOKIE);
};
exports.clearCheckoutRedirectionCookie = clearCheckoutRedirectionCookie;
$(document).ready(function () {
    addLoginRedirectToField();
    addSignupRedirectToField();
});
